import { Component, OnDestroy } from '@angular/core';
import { ModalService } from '@app/services/modal.service';

@Component({
  selector: 'app-modal-limit-date',
  templateUrl: './modal-limit-date.component.html',
  styleUrls: ['./modal-limit-date.component.scss']
})
export class ModalLimitDateComponent implements OnDestroy {

  constructor(public modal: ModalService) { }

  ngOnDestroy() {
    this.modal.close();
  }

  close() {
    this.modal.close();
  }

}
